import { Header } from "./Header";
import { Footer } from "./Footer";

export const PageShell = ({ children, back, onBack, bg = "cream" }) => (
  <div
    className={`min-h-screen w-full text-ink antialiased ${
      bg === "cream" ? "bg-cream" : "bg-beige"
    }`}
  >
    <div className="mx-auto flex min-h-screen w-full max-w-md flex-col px-6 pb-6">
      <Header showBack={!!back} onBack={onBack} />
      <main className="flex flex-1 flex-col">{children}</main>
      <Footer />
    </div>
  </div>
);
